define('plugins/musicfavourite/util',["require", "exports", "jquery-1.9", "./model/item"], function (require, exports, $, Item) {
    "use strict";
    exports.__esModule = true;
    function apply(receiver, apply) {
        for (var key in apply) {
            receiver[key] = apply[key];
        }
        return receiver;
    }
    exports.apply = apply;
    function parseItem(input, appId) {
        return new Item(input, appId);
    }
    exports.parseItem = parseItem;
    exports.json = {
        parse: function (string) {
            if (JSON && JSON.parse) {
                return JSON.parse(string);
            }
            return $.parseJSON(string);
        },
        _stringify: function (object) {
            var type = typeof object;
            if (type == 'undefined' || type == 'number' || type == 'boolean') {
                return String(object);
            }
            if (type == 'string') {
                return object;
            }
            if (object.toJSON && typeof (object.toJSON) == 'function') {
                return exports.json.stringify(object.toJSON());
            }
            var ret = [];
            if (object instanceof Array) {
                var item = void 0;
                for (var id = 0; item = object[id]; id++) {
                    ret.push(exports.json.stringify(item) || 'null');
                }
                return '[' + ret.join(',') + ']';
            }
            for (var id in object) {
                var item = object[id];
                type = typeof id;
                if (type === 'number') {
                    id = '"' + id + '"';
                }
                else {
                    continue;
                }
                type = typeof item;
                if (type === 'function' || type === 'undefined') {
                    continue;
                }
                item = exports.json.stringify(item);
                ret.push(id + ':' + item);
            }
            return '{' + ret.join(',') + '}';
        },
        stringify: function (object) {
            if (JSON && JSON.stringify) {
                return JSON.stringify(object);
            }
            return exports.json._stringify(object);
        }
    };
    function ArrayIterator(array, reverse_flag) {
        this.array = array.slice(0);
        this.length = this.array.length || 0;
        this.idx = reverse_flag ? this.length : -1;
    }
    exports.ArrayIterator = ArrayIterator;
    ArrayIterator.prototype = {
        hasNext: function () {
            return this.idx < this.length - 1;
        },
        hasPrevious: function () {
            return this.idx > 0;
        },
        next: function () {
            this.idx++;
            return this.array[this.idx];
        },
        previous: function () {
            this.idx--;
            return this.array[this.idx];
        }
    };
});
//# sourceMappingURL=util.js.map;
